import React from "react";
import styles from "./Styles/EventHero.module.css";
import { getDownloadLink } from "../../utils/appLinks";

const EventHero: React.FC = () => {
  return (
    <div className={styles.hero}>
      <div className={styles.left}>
        <span className={styles.eyebrow}>Live events near you</span>

        <h1 className={styles.title}>
          Find Amazing Events <br />
          happening in{" "}
          <span className={styles.inlineImage}>
            <img
              src="https://plus.unsplash.com/premium_photo-1722945739964-52a28d749264?q=80&w=1512&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="Live concert crowd"
            />
          </span>{" "}
          <br />
          Your{" "}
          <span className={styles.inlineImage}>
            <img
              src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              alt="City skyline"
            />
          </span>{" "}
          <span className={styles.highlight}>City.</span>
        </h1>

        <p className={styles.description}>
          Discover exciting concerts, food festivals, conferences, and
          nightlife events happening right now in your city. Stay in the
          loop and never miss out on what's happening around you.
        </p>

          <a href={getDownloadLink()} target="_blank" rel="noopener noreferrer">
        <button className={styles.ticketBtn}>
            Get Ticket <span className={styles.ticketEmoji}>🎟️</span>
        </button>
          </a>

        <div className={styles.brands}>
          <span className={styles.brandsLabel}>As seen at</span>
          <img
            src="https://images.unsplash.com/photo-1505373877841-8d25f7d46678?q=80&w=1624&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Border music festival"
          />
          <img
            src="https://images.unsplash.com/photo-1690192053520-c44899a79fb3?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Hues conference"
          />
          <img
            src="https://images.unsplash.com/photo-1531058020387-3be344556be6?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt="Leafe expo"
          />
        </div>
      </div>

      <div className={styles.right}>
        <div className={styles.categoryBox}>
          <span>
            We have many category <br /> event process
          </span>
          <div className={styles.playCircle}>
            <span className={styles.playRing} />
            <div className={styles.playIcon}>▶</div>
          </div>
        </div>

        <div className={styles.ticketGraphic}>
          <div className={styles.floatingBadge}>🔥 Selling fast</div>
          <img src="/images/ticket.png" alt="Event ticket" />
        </div>
      </div>
    </div>
  );
};

export default EventHero;